<style scoped lang="scss" type="text/scss">
    .single-image-uploader {
        width: 12rem;
        height: 12rem;
        position: relative;

        .tip-placeholder.circular {
            border-radius: 50%;
        }

        .avatar-container {
            width: 100%;
            height: 100%;

            &:hover {
                cursor: pointer;

                .shadow-placeholder {
                    opacity: 1;
                }
            }

            .file-upload {
                font-size: 2.5rem;
                color: #EEE;
            }

            .shadow-placeholder {
                opacity: 0;
                display: flex;
                flex-direction: column;
            }

        }
    }
</style>

<template>
    <i-multi-upload ref="uploader" class="single-image-uploader"
                     v-model="uploadImage"
                     :limit-types="limitTypes"
                     :limit-size="limitSize"
                     :limit-width="limitWidth"
                     :limit-height="limitHeight"
                     :circular="circular"
                     :is-image="true"
                     :auto-upload="false"
                     @on-add="onAdd"
                     @on-uploading="onUploading"
    >
<!--        <tip-placeholder class="tip-placeholder" :reversed="reversed" :class="{circular: circular}" :title="title"-->
<!--                         v-if="isActiveSrcNull"></tip-placeholder>-->
        <!-- 注：用自己的方式实现 auto-upload -->

<!--        <normal-image class="avatar-container" :src="activeSrc"-->
<!--                      :circular="circular">-->
<!--            <shadow-placeholder :circular="circular" class="shadow-placeholder">-->
<!--                <i class="icon file-upload">&#xe60d;</i>-->
<!--                <slot></slot>-->
<!--            </shadow-placeholder>-->
<!--        </normal-image>-->
    </i-multi-upload>
</template>

<script>
    import NormalImage from '../normal-image/index';
    import ShadowPlaceholder from '../shadow-placeholder/index';
    import IMultiUpload from '../i-uploader/multi';
    import TipPlaceholder from './tip-placeholder';

    export default {
        name: '',
        props: {
            value: {
                default () {
                    return [];
                }
            },
            autoUpload: {
                type: Boolean,
                default: true
            },
            limitTypes: {
                type: Array,
                default () {
                    return [];
                }
            },
            limitSize: {
                type: Number,
                default: null
            },
            limitWidth: {
                type: Number,
                default: null
            },
            limitHeight: {
                type: Number,
                default: null
            },
            circular: {
                type: Boolean,
                default: false
            },
            src: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: '图片'
            },
            reversed: {
                type: Boolean,
                default: false
            }
        },
        components: {
            NormalImage,
            ShadowPlaceholder,
            IMultiUpload,
            TipPlaceholder
        },
        data () {
            return {
                uploadImage: null,
                activeSrc: ''
            };
        },
        computed: {
            isActiveSrcNull () {
                const activeSrc = this.activeSrc;
                return null === activeSrc || '' === activeSrc || undefined === activeSrc;
            }
        },
        watch: {
            src: {
                immediate: true,
                handler (src) {
                    this.activeSrc = src;
                }
            },
            uploadImage: {
                deep: true,
                handler (uploadImage) {
                    this.$emit('input', uploadImage);
                    if (uploadImage === null) {
                        this.activeSrc = null;
                    }
                }
            },
            value (value) {
                this.uploadImage = value;
            }
        },
        methods: {
            upload () {
                this.$refs.uploader.upload();
            },
            trigger () {
                this.$refs.uploader.trigger();
            },
            sync (file) {
                this.$emit('input', file);
            },
            onAdd (file) {
                this.activeSrc = URL.createObjectURL(file.raw);
                // 将内部函数作为回调函数上抛
                this.$emit('on-add', file, this.upload);
                // 注：用自己的方式实现 auto-upload
                if (this.autoUpload) {
                    this.upload();
                }
            },
            throwSuccess (response) {
            },
            throwFail (err) {
                // 还原头像
                this.activeSrc = this.src;
            },
            onUploading (promise) {
                promise.then(response => {
                    // 由调用方最终确认是否上传成功
                    this.$emit('file-uploaded', response, this.throwSuccess, this.throwFail);
                }).catch(error => {
                    this.throwFail(error);
                });
            }
        }
    };
</script>
